import { useQuery } from '@tanstack/react-query';
import { fetchFeedbackTags } from '@/services/reputation';

export function useFeedbackTags(role: 'buyer_to_seller' | 'seller_to_buyer', enabled: boolean) {
  return useQuery({
    queryKey: ['feedback-tags', role],
    queryFn: () => fetchFeedbackTags(role),
    enabled,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
